export default "__VITE_ASSET__C6N$G$4s__"